import { Outlet } from "react-router-dom";
import TopNav, { TopNavWithSearch } from "./TopNav";
import FootNav from "./FootNav";
import { useEffect, useState } from "react";

export function Layout() {
  const [isReel, setIsReel] = useState(false);
  useEffect(() => {
    if (window.location.pathname === "/reel") {
      setIsReel(true);
    } else {
      setIsReel(false);
    }
    console.log(isReel);
  }, [isReel]);

  return (
    <>
      {isReel ? <TopNavWithSearch /> : <TopNav />}
      <Outlet />
      <FootNav />
    </>
  );
}
